// routes/Rootroute.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { roleToRoute } from "./roleRoutes";
  
const Home = () => {
  const navigate = useNavigate();
  const { authenticated, role } = useAuth();

  useEffect(() => {
    const route = roleToRoute[role];

    const timer = setTimeout(() => {
      if (authenticated && route) {
        navigate(route);
      } else if (!authenticated) {
        navigate("/login");
      } else {
        navigate("/restricted-access"); // fallback for undefined roles
      }
    }, 500); // Reduce delay for better UX

    return () => clearTimeout(timer);
  }, [authenticated, role, navigate]);

  return null;
};

export default Home;
